const en = {
  refill_title: 'Refill',
  refill_title_more_info: 'Info',
  refill_label_active_bundle: 'Active bundle name',
  refill_label_more_info: 'Info',
  refill_label_choose_amount: 'Choose the bundle',
  refill_label_payment_method: 'Payment method',
  refill_label_airtime: 'Airtime %1$s ',
  refill_label_congratulations: 'Congratulations!',
  refill_label_problem: 'Oops, there’s a problem!',
  refill_label_dates_used: 'Dates used',
  refill_label_available_days: 'Available days',
  refill_bundle_availability_description: 'The bundle is available until %1$s.',
  refill_insufficient_airtime_description: 'You don’t not have sufficient airtime balance. Top-up now and continue with the purchase of the bundle.',
  refill_purchased_package_description: 'The bundle has %1$s for %1$s.',
  refill_purchased_package_information: 'You now have %1$s extra in your plan.',
  refill_purchase_product_confirm: 'Are you sure you want to purchase this product?',
  refill_overwrite_bundle_confirm: 'Are you sure you want to overwrite your active bundle?',
  refill_button_confirm: 'Confirm',
  refill_button_cancel: 'Cancel',
  refill_button_go_back: 'Go back',
  refill_button_yes: 'Yes',
  refill_button_continue: 'Continue',
  refill_button_loading: 'Processing',
  refill_button_top_up: 'Top-Up',
  refill_currency: 'ALL',

  refill_label_payment_options: 'Payment options',
  refill_payment_option_airtime: 'Airtime',
  refill_payment_option_bill: 'Send to bill',
  refill_payment_option_next: 'Continue',

  refill_confirm_header_title: 'Activate Bundle',
  refill_confirm_title: 'Are you sure you want to activate this bundle?',
  refill_confirm_cost: 'Cost ',
  refill_confirm_desc: 'You will be charged on the next bill.',
}

export default en
